import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { MaterialIcon } from '~src/new/shared/ui/MaterialIcon/MaterialIcon'
import cls from './header-account-selector.module.scss'
import { HeaderDropdown } from './HeaderDropdown'
import { useWidth } from '~src/new/app/providers/WidthProvider'
import { AccountItemHeader, AccountList } from '~src/new/widgets/AccountList'
import { useMember } from '~src/new/app/providers/MemberProvider'
import { useModalSheet } from '~src/new/app/providers/ModalSheetProvider'
import { useBool } from '~src/new/shared/lib/useBool'

const ACCOUNT_LIST_ID = 'account-list-modal'

/**
 * Селектор компании с dropdown
 */
export const HeaderAccountSelector = ({
  className,
  iconName = 'place',
  isMobile: isMobileProp,
}) => {
  const { isMobile: isMobileByWidth } = useWidth()
  const isMobile = isMobileProp !== undefined ? isMobileProp : isMobileByWidth
  const { member, selectedAccount } = useMember()
  const { value: isOpen, onToggle, onFalse: onClose } = useBool()
  const { toggleModal, closeModal, id } = useModalSheet()

  const hasMultipleAccounts = useMemo(() => {
    return member?.accounts?.length > 1
  }, [member])

  const onCloseHandler = useCallback(() => {
    if (isMobile) {
      console.log('onCloseHandler')
      closeModal()
    } else {
      onClose()
    }
  }, [onClose, isMobile, closeModal])

  const list = useMemo(() => {
    if (!hasMultipleAccounts) return null
    return (
      <AccountList
        accounts={member?.accounts || []}
        selectedAccountId={selectedAccount?._id}
        onClose={onCloseHandler}
      />
    )
  }, [member, selectedAccount, hasMultipleAccounts, onCloseHandler])

  const handleToggle = useCallback(() => {
    if (isMobile) {
      toggleModal({
        id: ACCOUNT_LIST_ID,
        content: list,
        props: {
          snapPoints: [0.6, 0.6, 0],
          initialSnap: 1,
          theme: 'black',
        },
      })
    } else {
      onToggle()
    }
  }, [list, toggleModal, onToggle, isMobile])

  const isAccountListOpen = useMemo(() => {
    return id === ACCOUNT_LIST_ID || isOpen
  }, [id, isOpen])

  return (
    <button
      className={classNames(cls.companySelector, className, {
        [cls.open]: isAccountListOpen,
        [cls.disabled]: !hasMultipleAccounts,
      })}
      onClick={handleToggle}
      type="button"
    >
      {iconName && (
        <MaterialIcon
          name={iconName}
          ariaLabel="Местоположение"
          containerClassName={cls.icon}
          size={27}
          withContainer
          containerSize={32}
        />
      )}

      <AccountItemHeader account={selectedAccount} isOnlyName={isMobile} oneLineAddress />

      {hasMultipleAccounts && (
        <MaterialIcon
          name="keyboard_arrow_down"
          ariaLabel="Стрелка вниз"
          containerClassName={cls.chevron}
          withContainer
        />
      )}
      {!isMobile && (
        <HeaderDropdown isOpen={isOpen} onClose={onClose} className={cls.dropdown} maxHeight={232}>
          {list}
        </HeaderDropdown>
      )}
    </button>
  )
}

HeaderAccountSelector.propTypes = {
  className: PropTypes.string,
  iconName: PropTypes.string,
  isMobile: PropTypes.bool,
}
